/**
 * Bus Services Index
 * Tüm otobüs servislerini export eder
 */

import { ferryAuthService } from "./auth";
import { ferryBasicService } from "./basic";
import { ferryHomeService } from "./home";
import { ferryRouteService } from "./route";
import { ferryLocationService } from "./location";
import { ferryCompanyService } from "./company";
import { ferryCityService } from "./city";
import { ferryPopularService } from "./popular";
import { ferrySearchService } from "./search";
import { ferrySalesService } from "./sales";

// Individual service exports
export { ferryAuthService };
export { ferryBasicService };
export { ferryHomeService };
export { ferryRouteService };
export { ferryLocationService };
export { ferryCompanyService };
export { ferryCityService };

/**
 * Tüm servisleri tek obje olarak export et
 */
export const ferryServices = {
  auth: ferryAuthService,
  basic: ferryBasicService,
  home: ferryHomeService,
  route: ferryRouteService,
  location: ferryLocationService,
  company: ferryCompanyService,
  city: ferryCityService,
  popular: ferryPopularService,
  search: ferrySearchService,
  sales: ferrySalesService,
};

export default ferryServices;
